require('./ctxSwitchButton.style.scss');

class ctxSwitchButtonController {
    constructor($attrs, $scope) {
        this.$attrs = $attrs;
        this.$scope = $scope;
        let unwatch = this.$scope.$watch(() => this.$attrs.eventId, (value) => {
            if (!value) return;
            this.id = value;
            unwatch();
        })
    }
}

ctxSwitchButtonController.$inject = ['$attrs', '$scope'];

const ctxSwitchButtonComponent = {
    restrict: 'E',
    controller: ctxSwitchButtonController,
    require: ['ngModel'],
    scope: {},
    template: require('./ctxSwitchButton.template.html'),
    bindings: {
        form: '<',
        inputLabel: '@?',
        inputSubLabel: '@?',
        value: '=',
        inputName: '@',
        iconTooltip: '@',
        iconTooltipText: '@',
        onChange: '&?',
        isDisabled: '<?'
    }
};

module.exports = ctxSwitchButtonComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxSwitchButton/ctxSwitchButton.component.js